export default "__VITE_ASSET__HalE39ZM__"